import React from 'react';
import { Button } from 'react-bootstrap'
import * as App from 'modules/app/App'

class Impersonation extends React.Component {

    render() {
        const context = App.context();

        // Has permissions?
        if (!App.hasPrivilege("OperationsImpersonationAccess") && !context.impersonating) 
            return null;
                           
        if (!context.impersonating)
            return (<Button bsStyle="link" style={{ color: "white" }} onClick={this.props.onImpersonation}>Impersonation</Button>)
        else
            return (<Button bsStyle="link" style={{ color: "white" }} onClick={this.props.onRevertImpersonation}>Revert Impersonation</Button>)
    }
}

export default Impersonation;



// WEBPACK FOOTER //
// ./src/layouts/main/userCard/Impersonation.js